import { DatePipe } from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ExportExcelService } from 'src/app/common/services/export-excel.service';
import {IEntityDocumentSummary} from '../../../message-models/entity-document-summary';
import {IAllowedOperations} from "../../../users/models/userInfo.interface";

@Component({
  selector: 'app-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: ['./documents-list.component.scss']
})
export class DocumentsListComponent implements OnInit {
  @Input() showTableCaption: boolean;
  @Input() showHeaderText = true;
  isOnMobile = false;
  @Input() headerText = 'Documents';
  @Input() showCount = false;
  @Input() addDocumentButtonText = 'Add';
  @Input() showAddDocumentButton = true;
  @Input() showRowControllerButtons = false;
  @Input() allowedOperations: IAllowedOperations;
  @Input() documents: Array<IEntityDocumentSummary>  = new Array<IEntityDocumentSummary>();
  @Output() openDocument: EventEmitter<IEntityDocumentSummary> = new EventEmitter<IEntityDocumentSummary>();
  @Output() editDocument: EventEmitter<IEntityDocumentSummary> = new EventEmitter<IEntityDocumentSummary>();
  @Output() downloadDocument: EventEmitter<IEntityDocumentSummary> = new EventEmitter<IEntityDocumentSummary>();
  @Output() deleteDocument: EventEmitter<IEntityDocumentSummary> = new EventEmitter<IEntityDocumentSummary>();
  @Output() addDocument: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewDocument: EventEmitter<IEntityDocumentSummary> = new EventEmitter<IEntityDocumentSummary>();
  @Output() addObservationClicked: EventEmitter<IEntityDocumentSummary> = new EventEmitter<IEntityDocumentSummary>();
  @Output() refreshDocumentsRequested: EventEmitter<boolean> = new EventEmitter<boolean>();


  columns: any[];
  exportColumns: any[];
  expiredFilter =  { includeExpired : false };
  DocumentSummariesToExport: any[] = [];
  rowMenuItems: MenuItem[];

  constructor(private datePipe: DatePipe,private exportExcelService: ExportExcelService) {
    this.columns = [
      {field: 'documentType', header: 'Type', type: 'text'},
      {field: 'documentCreationDate', header: 'Created On', type: 'date'},
      {field: 'reviewDate', header: 'Review Due', type: 'date'},
      {field: 'expiryDate', header: 'Expires On', type: 'date'},
      {field: 'originalFilename', header: 'Original Filename', type: 'text'},
      {field: 'totalObservations', header: 'Observations', type: 'text'},
    ];

    this.exportColumns = [
      {field: 'documentType', header: 'Type'},
      {field: 'documentCreationDate', header: 'Created On'},
      {field: 'reviewDate', header: 'Review Due'},
      {field: 'expiryDate', header: 'Expires On'},
      {field: 'originalFilename', header: 'Original Filename'},
      {field: 'totalObservations', header: 'Observations'},
    ]
  }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.rowMenuItems = [
      {
        label: 'Preview',
        icon: 'fas fa-search',
        state: { 'contextLogic': 'canPreviewDocument' },
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.openDocumentClicked($event)
      },
      {
        label: 'Download',
        icon: 'fas fa-download',
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.downloadDocumentClicked($event)
      },
      {
        label: 'Add Observation',
        icon: 'fas fa-eye',
        visible: this.showRowControllerButtons,
        styleClass: 'eca-menu-item-green',
        command: ($event) => this.addObservationToADocumentClicked($event)
      },
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        visible: this.allowedOperations?.canDelete,
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteDocumentClicked($event)
      }
    ]
  }

  openDocumentClicked(entityDocument: IEntityDocumentSummary) {
    this.openDocument.emit(entityDocument);
  }

  deleteDocumentClicked(entityDocument: IEntityDocumentSummary) {
    this.deleteDocument.emit(entityDocument);
  }

  downloadDocumentClicked(entityDocument: IEntityDocumentSummary) {
    this.downloadDocument.emit(entityDocument);
  }

  editDocumentClicked(entityDocument: IEntityDocumentSummary) {
    this.editDocument.emit(entityDocument);
  }

  addDocumentClicked() {
    this.addDocument.emit();
  }

  viewDocumentClicked(entityDocument: IEntityDocumentSummary) {
    this.viewDocument.emit(entityDocument);
  }

  expiredFilterChanged() {
    this.refreshDocumentsRequested.emit(this.expiredFilter.includeExpired);
  }
  exportToExcel() {
    this.DocumentSummariesToExport = [];
    this.documents.forEach(element =>{
      const tempObject = {
        documentType: element.documentType,
        documentCreationDate : this.datePipe.transform(element.documentCreationDate?.dateTime, 'dd/MM/yyyy'),
        reviewDate : this.datePipe.transform(element.reviewDate?.dateTime, 'dd/MM/yyyy'),
        expiryDate : this.datePipe.transform(element.expiryDate?.dateTime, 'dd/MM/yyyy'),
        originalFilename: element.originalFilename,
        totalObservations: element?.totalObservations
      };
      this.DocumentSummariesToExport.push(tempObject);
    });
    this.exportExcelService.exportToExcel(this.DocumentSummariesToExport, this.exportColumns, this.headerText.toString())

  }

  addObservationToADocumentClicked(entityDocument: IEntityDocumentSummary) {
    this.addObservationClicked.emit(entityDocument)
  }
}
